export default __webpack_public_path__ + "static/media/past.843143a3.svg";